import { CalendarIntegration } from '../../calendar/CalendarIntegration';
import { PendingTab } from './PendingTab';

export interface PersonCalendarTabProps {
  /** Person.userId — the linked login account. Null when the person has none. */
  userId: string | null;
}

/**
 * Calendar tab for the Team Member detail page (CLE-237). Reuses the per-user
 * Google Calendar integration shipped in CLE-236. People without a linked user
 * account cannot connect a calendar, so we show an explanatory placeholder.
 */
export function PersonCalendarTab({ userId }: PersonCalendarTabProps) {
  if (!userId) {
    return (
      <PendingTab
        title="Calendar"
        description="Acest membru al echipei nu are un cont de autentificare asociat, așa că un Google Calendar nu poate fi conectat încă. Creează-i un cont pentru a activa sincronizarea calendarului per utilizator."
      />
    );
  }
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <CalendarIntegration userId={userId} />
    </div>
  );
}
